import { styled } from '@mui/material/styles';
import { Box, alpha } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(14, 0),
  background: `linear-gradient(
      180deg, 
      ${theme.palette.common.black} 0%, 
      ${alpha(theme.palette.common.black, 0.39)},
      ${theme.palette.background.primary},
      ${theme.palette.background.primary})`,
  '& .PDSInfoSection': {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  '& .PDSImageSide': {
    display: 'flex',
    justifyContent: 'end',
    position: 'relative',
  },
  '& .PDSImageContainer': {
    maxWidth: '100%',
    width: theme.typography.pxToRem(772),
    height: theme.typography.pxToRem(532),
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down('xl')]: {
      width: theme.typography.pxToRem(452),
    },
    [theme.breakpoints.down('lg')]: {
      width: theme.typography.pxToRem(628),
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },

  },
  '& .PDSSubImageContainer': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: theme.typography.pxToRem(364),
    height: theme.typography.pxToRem(266),
    [theme.breakpoints.down('lg')]: {
      left: theme.spacing(8),
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      left: theme.spacing(9.5),
      maxWidth: theme.typography.pxToRem(313),
      height: theme.typography.pxToRem(228),
    },

  },
  '& .PDSDesc': {
    display: '-webkit-box',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.common.fogWhite,
    fontSize: theme.typography.pxToRem(21),
    fontWeight: 400,
  },
}));

export default StyledBox;
